/*
  Tecnocom 2026-10-07 — medición del embudo entre el carrito y el pago.

  Por qué: en los últimos 30 días, de 49 sesiones con carrito solo 14 llegaron al pago, y en computadora 8 de 39
  (celular 6 de 10). Desde el 2026-09-11 el «Pagar pedido» del cajón lleva a /cart (formulario de factura) y no directo
  al pago: antes de cambiar nada, Adrian pidió MEDIR en qué paso se va el cliente.

  Eventos (GA4 por `gtag`, el mismo que inyecta el canal de Google; y Shopify.analytics.publish para un pixel futuro).
  Prefijo `tc_` para no chocar con los estándar (view_cart, begin_checkout) que ya manda el canal:
    tc_cajon_abierto   se abre el cajón del carrito            {items, value}
    tc_cajon_pagar     clic en «Pagar pedido» del cajón        {items, value}
    tc_cajon_cerrado   se cierra el cajón SIN ese clic         {items, value}
    tc_cart_vista      se ve /cart                             {items, value}
    tc_cart_pagar      clic en «Pagar pedido» de /cart         {items, value, factura}
    tc_cart_express    clic en un botón de pago exprés         {items, value}
  Los clics van con transport_type: 'beacon' (la página se va enseguida). Todo protegido: sin gtag no pasa nada.
  Respeta el consentimiento: va por el mismo gtag que Shopify gobierna con la API de privacidad.
*/
(function () {
  'use strict';
  if (window.__tcEmbudo) return;
  window.__tcEmbudo = true;

  var carrito = { items: 0, value: 0 };

  function enviar(nombre, extra, salida) {
    var datos = { items: carrito.items, value: carrito.value, currency: 'MXN' };
    for (var k in (extra || {})) datos[k] = extra[k];
    if (salida) datos.transport_type = 'beacon';
    try { if (window.gtag) window.gtag('event', nombre, datos); } catch (e) { /* sin GA */ }
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, datos);
    } catch (e) { /* sin eventos */ }
  }

  function leerCarrito() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { carrito = { items: c.item_count || 0, value: (c.total_price || 0) / 100 }; return carrito; })
      .catch(function () { return carrito; });
  }

  // ── /cart ──
  if (location.pathname.replace(/\/$/, '') === '/cart') {
    leerCarrito().then(function () { enviar('tc_cart_vista'); });
  }

  // ── Cajón: abrir / cerrar ──
  var pagoDesdeCajon = false;
  function vigilarCajon(cajon) {
    var abierto = cajon.classList.contains('active');
    new MutationObserver(function () {
      var ahora = cajon.classList.contains('active');
      if (ahora === abierto) return;
      abierto = ahora;
      if (ahora) {
        pagoDesdeCajon = false;
        leerCarrito().then(function () { enviar('tc_cajon_abierto'); });
      } else if (!pagoDesdeCajon) {
        enviar('tc_cajon_cerrado');
      }
    }).observe(cajon, { attributes: true, attributeFilter: ['class'] });
  }
  function buscarCajon() {
    var c = document.querySelector('cart-drawer');
    if (c) vigilarCajon(c);
    return !!c;
  }
  if (!buscarCajon()) document.addEventListener('DOMContentLoaded', buscarCajon);

  // ── Clics (delegados: el cajón y /cart se re-pintan por innerHTML) ──
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var enCajon = t.closest('cart-drawer');
    if (enCajon && t.closest('a[href="/cart"]') && /pagar/i.test(t.closest('a').textContent || '')) {
      pagoDesdeCajon = true;
      enviar('tc_cajon_pagar', null, true);
      return;
    }
    if (!enCajon && t.closest('button[name="checkout"], input[name="checkout"]')) {
      var f = document.querySelector('[name="attributes[Requiere factura]"]');
      enviar('tc_cart_pagar', { factura: f ? f.value : '' }, true);
      return;
    }
    if (t.closest('.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons')) {
      enviar('tc_cart_express', null, true);
    }
  }, true);
})();
